import React, { useEffect } from 'react';
import { KFLDialog } from '@kamstrup/kamstrup-frontend-library';
import { connect } from 'react-redux';
import DialogHeader from '../shared/dialog/dialogHeader';
import ReadRightDetails from './readRightDetails';
import ReadRightMode from './readRightsMode';
import { ReduxState } from '../../interfaces';
import Translate from '../shared/localization/localize';
import * as ReadRights from '../../modules/dialogs/readRights';
import DialogSection from '../shared/dialog/dialogSection';
import { Groups } from '../../models';
import { setItems } from '../../modules/dialogs/readRights';
import useDialog from '../shared/dialog/useDialog';
import './readRights.scss';

interface StateProps extends ReadRights.State {
  selectedDevices: string[];
  selectedOrders: string[];
  selectedProducts: string[];
}

type Props = StateProps;

const ReadRightEditDialog: React.FC<Props> = (props) => {
  const { setDialog } = useDialog();
  useEffect(() => {
    if (props.groupedBy === Groups.DEVICES) setItems(props.selectedDevices);
  }, [props.groupedBy, props.selectedDevices]);

  useEffect(() => {
    if (props.groupedBy === Groups.ORDERS) setItems(props.selectedOrders);
  }, [props.groupedBy, props.selectedOrders]);

  useEffect(() => {
    if (props.groupedBy === Groups.DEVICETYPES)
      setItems(props.selectedProducts);
  }, [props.groupedBy, props.selectedProducts]);

  const content = (
    <>
      <DialogSection>
        <ReadRightMode
          key="md-readrights-mode"
          keys={props.keys}
          groupedBy={props.groupedBy}
          mode={props.mode}
        />
      </DialogSection>
      <DialogSection>
        <ReadRightDetails />
      </DialogSection>
    </>
  );

  return (
    <KFLDialog
      header={
        <DialogHeader
          title={<Translate message={ReadRights.msgEditHeader} />}
          fnCloseDialog={() => setDialog?.()}
        />
      }
      sections={[content]}
    />
  );
};

const mapStateToProps = (state: ReduxState): StateProps => ({
  ...state.dialogState.readrightState,
  selectedDevices: state.devicesState.selection.selectedKeys,
  selectedOrders: state.ordersState.selection.selectedKeys,
  selectedProducts: state.deviceTypesState.selection.selectedKeys,
});

export default connect(mapStateToProps)(ReadRightEditDialog);
